(function () {
  'use strict';

  function init() {
    var links = document.querySelectorAll('[data-sc-fq-link]');
    var groups = document.querySelectorAll('[data-sc-fq-group]');
    if (!links.length || !groups.length) return;

    // smooth scroll that respects the sticky header offset baked into scroll-margin
    [].forEach.call(links, function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (!id || id.charAt(0) !== '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', id);
      });
    });

    if (!('IntersectionObserver' in window)) return;

    var visible = {};
    var paint = function () {
      var first = null;
      [].forEach.call(groups, function (g) { if (!first && visible[g.id]) first = g.id; });
      [].forEach.call(links, function (a) {
        var on = a.getAttribute('data-sc-fq-link') === first;
        if (on) a.classList.add('is-active'); else a.classList.remove('is-active');
      });
    };

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { visible[e.target.id] = e.isIntersecting; });
      paint();
    }, { rootMargin: '-15% 0px -65% 0px', threshold: 0 });

    [].forEach.call(groups, function (g) { io.observe(g); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
